// @flow
import React, { type Element } from 'react';
import { stylesColors } from 'angieslist-styles';

const styles = {
  iconStackForeground: {
    color: stylesColors.darkGray,
  },
  iconStackBackground: {
    color: stylesColors.lightestGray,
    textShadow: `0 0 1px ${stylesColors.darkGray}`,
  },
};

type Props = {
  iconClassName: string,
  size?: number | string,
};


const CircularIcon = ({
  iconClassName,
  size,
}: Props): Element<"span"> => (
  <span className="icon-stack" style={{ fontSize: size }}>
    <i className="icon icon-circle icon-stack-2x" style={styles.iconStackBackground} />
    <i className={`icon ${iconClassName} icon-stack-1x`} style={styles.iconStackForeground} />
  </span>
);

CircularIcon.defaultProps = {
  size: 20,
};

export default CircularIcon;



// WEBPACK FOOTER //
// ./src/modules/home/browser/components/Dashboard/CircularIcon.js